export default __webpack_public_path__ + "static/platform-80ba8e7a8adb913b3f4522bbf7e33f68.png";